export const isBrowser = () => typeof window !== 'undefined';
//# sourceMappingURL=helpers.js.map